/**
 * Lote crm7 (ficha 2026-10-29 "configuracoes-do-crm-igual-a-origem"): textos das Configurações do CRM no formato da origem
 * (cabeçalho de cada seção, listas, abas e menus). Fica em `crm.cfg` do namespace `pipeline`; o espanhol trata por "tú".
 */
export const cfgPt = {
  migalha: 'Configurações',
  voltar: 'Voltar às configurações',
  novo: 'Novo',
  lista: {
    pesquisar: 'Pesquisar...',
    descricao: 'Descrição',
    descricaoPlaceholder: 'Ex.: Ação de final de ano',
    opcoes: 'Opções',
    vazio: 'Nenhum item cadastrado.',
    selecionarTodos: 'Selecionar todos',
    selecionar: 'Selecionar {{nome}}',
    editar: 'Editar {{nome}}',
    excluir: 'Excluir {{nome}}',
    confirmarUm: 'Excluir "{{nome}}"?',
    confirmarTexto: 'O item sai da lista de escolha. O que já foi registrado com ele fica como está.',
    repetido: 'Já existe um item com esse nome',
  },
  sugestoes: { usuarios: 'Convide as pessoas da sua equipe para usar o CRM', usuariosBotao: 'Convidar usuários' },
  funis: {
    titulo: 'Funis de vendas',
    abaFunil: 'Funil de vendas',
    abaCrm2crm: 'CRM2CRM',
    adicionarFunil: 'Adicionar funil de vendas',
    nomeFunil: 'Nome do funil',
    placeholderFunil: 'Ex.: Pós-venda',
    copiarDe: 'Copiar as etapas de',
    semCopia: 'Etapas padrão',
    opcoesFunil: 'Opções do funil {{nome}}',
    renomear: 'Renomear',
    renomearTitulo: 'Renomear funil',
    arquivar: 'Arquivar funil',
    confirmarArquivar: 'Arquivar o funil {{nome}}?',
    confirmarArquivarTexto: 'O funil sai da escolha de funil e o histórico fica. Só dá para arquivar um funil sem negociações abertas.',
    arquivados_one: '{{count}} funil arquivado',
    arquivados_other: '{{count}} funis arquivados',
    desarquivar: 'Desarquivar',
    etapaConfigurada: 'Etapa configurada',
    adicionarEtapa: 'Adicionar etapa ao funil {{nome}}',
    excluirEtapa: 'Excluir etapa',
    etapas: 'Etapas do funil {{nome}}',
    etapasNovo: 'Etapas do funil',
    etapasNovoAjuda: 'Na ordem do quadro. Renomeie, acrescente e mude a ordem pelas setas ou arrastando.',
    nomeEtapaN: 'Nome da etapa {{n}}',
    etapaN: 'etapa {{n}}',
    novaEtapa: 'Adicionar etapa',
    removerEtapa: 'Remover a etapa {{nome}}',
    etapaRepetida: 'Já existe uma etapa com esse nome',
    faltaTipo: 'O funil precisa de ao menos uma etapa do tipo {{tipo}}',
  },
  campos: {
    titulo: 'Configurar campos de cadastro',
    abaNegociacao: 'Negociação',
    // Lista de 03/11, item 7: Empresas e Contatos viram duas abas; Produtos e Serviços é o catálogo (`cadastros.servico`).
    abaEmpresa: 'Empresas',
    abaContato: 'Contatos',
    abaProduto: 'Produtos e serviços',
    semPermissao: 'Os campos personalizados ficam nas configurações do sistema. Para vê-los aqui, peça a permissão de ver as configurações.',
  },
  produtos: {
    titulo: 'Produtos e serviços',
    intro: 'O catálogo de venda que a negociação usa. O formulário é o mesmo do botão "Criar novo produto/serviço".',
    criar: 'Criar produto/serviço',
    criarTitulo: 'Novo produto/serviço',
    editarTitulo: 'Editar produto/serviço',
    editar: 'Editar {{nome}}',
    buscar: 'Buscar por nome ou código',
    vazio: 'Nenhum produto ou serviço cadastrado.',
    semResultado: 'Nada encontrado para essa busca.',
    salvo: 'Produto/serviço salvo',
    verticalVarias: 'Várias verticais (manter como estão)',
    verticalSempreAjuda: 'Pode ser uma vertical fora do filtro da negociação: o cadastro é criado, mas não entra na lista dela.',
    foraDoFiltro: 'O cadastro "{{nome}}" foi criado em {{vertical}}, que está fora do filtro de vertical desta negociação. Ele não aparece na lista nem foi escolhido.',
    campos: 'Campos personalizados',
  },
  fontes: {
    abaFontes: 'Fontes',
    abaCampanhas: 'Campanhas',
    introFontes: 'Gerencie as fontes das negociações.',
    introCampanhas: 'Gerencie as campanhas das negociações.',
    livresFontes: 'Permitir que usuários criem novas fontes',
    livresCampanhas: 'Permitir que usuários criem novas campanhas',
    adicionarFontes: 'Adicionar fonte',
    adicionarCampanhas: 'Adicionar campanha',
    campoFontes: 'Nome da fonte',
    campoCampanhas: 'Nome da campanha',
    placeholderFontes: 'Ex.: Contato pelo site',
    placeholderCampanhas: 'Ex.: Google Ads',
    apagarSelFontes_one: 'Apagar a fonte selecionada',
    apagarSelFontes_other: 'Apagar as {{count}} fontes selecionadas',
    apagarSelCampanhas_one: 'Apagar a campanha selecionada',
    apagarSelCampanhas_other: 'Apagar as {{count}} campanhas selecionadas',
    apagarTodasFontes: 'Apagar todas as {{count}} fontes',
    apagarTodasCampanhas: 'Apagar todas as {{count}} campanhas',
    confirmarFontes: 'Apagar {{count}} fontes?',
    confirmarCampanhas: 'Apagar {{count}} campanhas?',
  },
  motivos: {
    titulo: 'Motivo de perda',
    intro1: 'Cadastre todos os motivos de perda de negociações da sua empresa.',
    intro2: 'Além dos relatórios, você terá filtros para acompanhar melhor as empresas e os clientes.',
    adicionar: 'Adicionar motivo de perda',
    campo: 'Motivo de perda',
    placeholder: 'Ex.: Não gostou do produto',
    coluna: 'Nome do motivo de perda',
    perdidas: 'Negociações perdidas',
    apagarSel_one: 'Apagar o motivo selecionado',
    apagarSel_other: 'Apagar os {{count}} motivos selecionados',
    apagarTodos: 'Apagar todos os {{count}} motivos de perda',
    confirmar: 'Apagar {{count}} motivos de perda?',
  },
  qualificacao: {
    sub: 'Defina critérios de qualificação para organizar e priorizar as negociações no funil.',
    autoTitulo: 'Qualificação automática via questionários',
    autoTexto_one: '{{count}} questionário qualifica as negociações pela pontuação das respostas.',
    autoTexto_other: '{{count}} questionários qualificam as negociações pela pontuação das respostas.',
    autoNenhum: 'Nenhum questionário qualifica ainda. Ligue a qualificação automática no questionário e defina as faixas de pontos.',
    autoLink: 'Ver os questionários',
    colQualificacao: 'Qualificação',
    colNome: 'Nome',
    editar: 'Editar {{nome}}',
    editarTitulo: 'Editar qualificação',
    nome: 'Nome da qualificação',
  },
  questionarios: {
    sub: 'Padronize as perguntas feitas aos clientes e o registro das respostas.',
    avisoTitulo: 'Automatize sua qualificação',
    avisoTexto: 'Classifique as negociações pela pontuação dos questionários. Para começar,',
    avisoLink: 'configure a qualificação',
    colQuestionario: 'Questionário',
    colPerguntas: 'Perguntas',
    colRespostas: 'Respostas',
    colEdicao: 'Última edição',
    colAtivo: 'Em uso',
    opcoes: 'Opções de {{nome}}',
    verRespostas: 'Ver respostas',
    excluir: 'Excluir',
    vazioTitulo: 'Dê o primeiro passo para padronizar a coleta de informações dos seus clientes',
    vazioTexto: 'Crie um questionário para que toda a equipe faça as mesmas perguntas e registre as respostas de forma organizada.',
    novo: 'Novo questionário',
  },
  modelos: {
    sub: 'Crie, edite e organize os modelos de proposta usados nas negociações.',
    criar: 'Criar modelo',
    filtro: 'Filtrar os modelos',
    todos: 'Todos os modelos',
    publicados: 'Publicados',
    rascunhos: 'Rascunhos',
    colModelo: 'Modelos de proposta',
    colStatus: 'Status',
    colAcoes: 'Ações',
    publicado: 'Publicado',
    rascunho: 'Rascunho',
    opcoes: 'Opções de {{nome}}',
    editar: 'Editar modelo',
    tornarPadrao: 'Tornar padrão',
    duplicar: 'Duplicar',
    copia: '{{nome}} (cópia)',
    duplicado: 'Modelo duplicado',
    moverRascunho: 'Mover para rascunho',
    publicar: 'Publicar',
    excluir: 'Excluir',
    vazio: 'Nenhum modelo neste filtro.',
    salvarAlteracoes: 'Salvar alterações',
    definicoes: 'Definições do modelo',
    conteudo: 'Conteúdo do modelo',
    novoTitulo: 'Novo modelo',
    salvo: 'Alterações salvas',
    naoEncontrado: 'Modelo não encontrado.',
  },
  modelosEmail: {
    intro: 'Cadastre modelos de e-mail para enviar aos contatos pelas negociações.',
    adicionar: 'Adicionar modelo',
    fechar: 'Fechar',
    apagarSel_one: 'Apagar o modelo selecionado',
    apagarSel_other: 'Apagar os {{count}} modelos selecionados',
    confirmarApagar_one: 'Apagar o modelo selecionado?',
    confirmarApagar_other: 'Apagar os {{count}} modelos selecionados?',
  },
  preferencias: {
    abaTroca: 'Troca e criação de negociações',
    abaArquivos: 'Central de arquivos',
    abaGatilhos: 'Gatilhos',
    abaNegociacao: 'Negociação',
    abaTokens: 'Tokens de API',
    celebrar: 'Ativar comemoração ao fechar uma venda?',
    celebrarAjuda: 'Ao marcar uma negociação como vendida, o CRM mostra a quem vendeu uma mensagem de comemoração com a quantidade e o valor das vendas do mês.',
  },
  // Lote crm8 (item 3): Central de Arquivos (Preferências) e o seletor "Arquivos da Central" do e-mail e da proposta.
  central: {
    intro1: 'Transforme esta página no repositório de arquivos da empresa: imagens, apresentações, portfólio e documentos padrão.',
    intro2: 'Os arquivos daqui podem ir como anexo no "Criar e-mail" e no envio da proposta, pelo botão "Arquivos da Central".',
    intro3: 'Defina se cada arquivo é exclusivo de quem gere a Central ou compartilhado com toda a equipe. Até {{limite}} por arquivo (imagem, PDF, Office, OpenDocument, texto ou CSV) e {{max}} arquivos.',
    upload: 'Enviar arquivos',
    enviando: 'Enviando {{nome}}...',
    enviados_one: 'Arquivo enviado',
    enviados_other: '{{count}} arquivos enviados',
    data: 'Data',
    arquivo: 'Arquivo',
    tamanho: 'Tamanho',
    adicionadoPor: 'Adicionado por',
    abrir: 'Abrir',
    abrirNome: 'Abrir {{nome}}',
    link: 'Link',
    copiarLink: 'Copiar o link de {{nome}}',
    linkCopiado: 'Link copiado',
    compartilhado: 'Compartilhado',
    compartilhadoNome: 'Compartilhar {{nome}} com toda a equipe',
    opcoes: 'Opções',
    excluirNome: 'Excluir {{nome}}',
    excluirTitulo: 'Excluir arquivo',
    excluirTexto: 'Excluir "{{nome}}" da Central? O que já foi enviado nos e-mails continua nas negociações.',
    excluido: 'Arquivo excluído',
    salvo: 'Preferência salva',
    vazio: 'Nenhum arquivo enviado.',
    semPermissao: 'Você vê os arquivos compartilhados. Enviar, compartilhar e excluir pede a permissão "Gerir a Central de Arquivos" e ver todas as empresas do workspace.',
    tipo: 'Tipo de arquivo não permitido: {{nome}}',
    grande: '{{nome}} passa de {{limite}}',
    escolher: 'Arquivos da Central',
    escolherTitulo: 'Arquivos da Central',
    escolherAjuda: 'Marque os arquivos que vão como anexo. Eles somam com os outros anexos no limite do e-mail.',
    escolherVazio: 'A Central de Arquivos ainda não tem arquivos compartilhados.',
    escolherConfirmar: 'Usar os arquivos marcados',
    escolherNome: 'Escolher {{nome}}',
    removerNome: 'Tirar {{nome}} do e-mail',
    daCentral: 'Da Central',
    texto: 'Texto sobre os arquivos (opcional)',
    textoAjuda: 'Entra no corpo do e-mail antes da assinatura (sem assinatura, no fim). Vem do texto modelo dos arquivos; pode mudar ou apagar. {{n}}/2000',
    // Lista de 30/10 (B), item 20: texto modelo do arquivo.
    textoModelo: 'Texto modelo (opcional)',
    textoModeloAjuda: 'Entra no corpo do e-mail, antes da assinatura, quando o arquivo for anexado. {{n}}/2000',
    textoModeloPlaceholder: 'Ex.: Veja em anexo o nosso portfólio de serviços.',
    enviarTitulo: 'Enviar à Central',
    enviarConfirmar: 'Enviar',
    editarTexto: 'Texto modelo de {{nome}}',
    textoSalvo: 'Texto modelo salvo',
    comTexto: 'Texto modelo: {{texto}}',
    textoPlaceholder: 'Ex.: Veja em anexo o nosso portfólio de serviços.',
    // Lista de 03/11: portfólio da vertical e geral, e o texto "Conheça nossos outros serviços".
    portfolioTitulo: 'Portfólios',
    portfolioIntro: 'Escolha o arquivo da Central que é o portfólio de cada vertical e o do grupo. Ao abrir o e-mail da aba E-mails ou o da proposta, o geral e o portfólio das verticais que não estão na negociação já vêm marcados; quem envia pode mudar antes de enviar.',
    portfolioGeral: 'Malgo Geral',
    portfolioSem: 'Sem arquivo',
    portfolioSelecionar: 'Arquivo do portfólio de {{nome}}',
    portfolioEmUso: '{{nome}} (portfólio de {{opcao}})',
    portfolioSalvarNome: 'Salvar o portfólio de {{nome}}',
    portfolioSalvo: 'Portfólio salvo',
    portfolioSemArquivosNaCentral: 'Envie os arquivos à Central para escolher os portfólios.',
    outrosTitulo: 'Conheça nossos outros serviços',
    outrosAjuda: 'Entra no corpo do e-mail da aba E-mails e do e-mail da proposta, e o endereço vira link. Deixe vazio para não incluir. {{n}}/500',
    outrosCampo: 'Texto dos outros serviços',
    outrosPlaceholder: 'Ex.: Conheça nossos outros serviços: https://malgo.com.br',
    outrosSalvo: 'Texto salvo',
    outrosPadrao: 'Voltar ao texto padrão',
    envioPortfolioTitulo: 'Portfólios',
    envioPortfolioAjuda: 'O geral do grupo e o portfólio das verticais que não estão na negociação vêm marcados. Desmarque o que não quiser: nada sai sozinho.',
    envioVerticaisErro: 'Não foi possível ler as verticais da negociação. Portfólio de vertical não veio marcado; marque aqui, se precisar.',
    envioPortfolioCarregando: 'Carregando os portfólios...',
    envioOutrosErro: 'Não foi possível carregar o texto de outros serviços. O e-mail segue sem ele; você pode escrevê-lo no corpo.',
    envioPortfolioErro: 'Não foi possível carregar os portfólios. O envio segue sem eles; você ainda pode anexar pela Central.',
    envioPortfolioFalta: 'Ainda sem arquivo. Suba em Configurações do CRM > Preferências > Central de arquivos.',
    envioPortfolioNaoCoube: '{{arquivo}} não coube nos limites do e-mail e ficou desmarcado. O link da Central pede login, então não vai no corpo.',
    envioPortfolioMarcar: 'Anexar o portfólio de {{opcao}}: {{arquivo}}',
    envioPortfolioSemArquivoNome: 'Portfólio de {{opcao}}: sem arquivo',
  },
};

export const cfgEn: typeof cfgPt = {
  migalha: 'Settings',
  voltar: 'Back to settings',
  novo: 'New',
  lista: {
    pesquisar: 'Search...',
    descricao: 'Description',
    descricaoPlaceholder: 'E.g.: Year-end promotion',
    opcoes: 'Options',
    vazio: 'No items yet.',
    selecionarTodos: 'Select all',
    selecionar: 'Select {{nome}}',
    editar: 'Edit {{nome}}',
    excluir: 'Delete {{nome}}',
    confirmarUm: 'Delete "{{nome}}"?',
    confirmarTexto: 'The item leaves the list of choices. What was already recorded with it stays as it is.',
    repetido: 'An item with this name already exists',
  },
  sugestoes: { usuarios: 'Invite the people on your team to use the CRM', usuariosBotao: 'Invite users' },
  funis: {
    titulo: 'Sales pipelines',
    abaFunil: 'Sales pipeline',
    abaCrm2crm: 'CRM2CRM',
    adicionarFunil: 'Add sales pipeline',
    nomeFunil: 'Pipeline name',
    placeholderFunil: 'E.g.: After-sales',
    copiarDe: 'Copy the stages from',
    semCopia: 'Default stages',
    opcoesFunil: 'Options for the {{nome}} pipeline',
    renomear: 'Rename',
    renomearTitulo: 'Rename pipeline',
    arquivar: 'Archive pipeline',
    confirmarArquivar: 'Archive the {{nome}} pipeline?',
    confirmarArquivarTexto: 'The pipeline leaves the pipeline choice and its history stays. Only a pipeline without open deals can be archived.',
    arquivados_one: '{{count}} archived pipeline',
    arquivados_other: '{{count}} archived pipelines',
    desarquivar: 'Unarchive',
    etapaConfigurada: 'Stage set up',
    adicionarEtapa: 'Add a stage to the {{nome}} pipeline',
    excluirEtapa: 'Delete stage',
    etapas: 'Stages of the {{nome}} pipeline',
    etapasNovo: 'Pipeline stages',
    etapasNovoAjuda: 'In board order. Rename, add and change the order with the arrows or by dragging.',
    nomeEtapaN: 'Name of stage {{n}}',
    etapaN: 'stage {{n}}',
    novaEtapa: 'Add stage',
    removerEtapa: 'Remove stage {{nome}}',
    etapaRepetida: 'There is already a stage with this name',
    faltaTipo: 'The pipeline needs at least one stage of type {{tipo}}',
  },
  campos: {
    titulo: 'Set up record fields',
    abaNegociacao: 'Deal',
    abaEmpresa: 'Companies',
    abaContato: 'Contacts',
    abaProduto: 'Products and services',
    semPermissao: 'Custom fields live in the system settings. To see them here, ask for the permission to view settings.',
  },
  produtos: {
    titulo: 'Products and services',
    intro: 'The sales catalog the deal uses. The form is the same as the "Create new product/service" button.',
    criar: 'Create product/service',
    criarTitulo: 'New product/service',
    editarTitulo: 'Edit product/service',
    editar: 'Edit {{nome}}',
    buscar: 'Search by name or code',
    vazio: 'No products or services yet.',
    semResultado: 'Nothing found for this search.',
    salvo: 'Product/service saved',
    verticalVarias: 'Several business units (keep as they are)',
    verticalSempreAjuda: 'It can be a business unit outside the deal filter: the record is created, but it does not enter the deal list.',
    foraDoFiltro: 'The record "{{nome}}" was created in {{vertical}}, which is outside this deal\'s business unit filter. It is not in the list and was not chosen.',
    campos: 'Custom fields',
  },
  fontes: {
    abaFontes: 'Sources',
    abaCampanhas: 'Campaigns',
    introFontes: 'Manage the sources of the deals.',
    introCampanhas: 'Manage the campaigns of the deals.',
    livresFontes: 'Allow users to create new sources',
    livresCampanhas: 'Allow users to create new campaigns',
    adicionarFontes: 'Add source',
    adicionarCampanhas: 'Add campaign',
    campoFontes: 'Source name',
    campoCampanhas: 'Campaign name',
    placeholderFontes: 'E.g.: Website contact',
    placeholderCampanhas: 'E.g.: Google Ads',
    apagarSelFontes_one: 'Delete the selected source',
    apagarSelFontes_other: 'Delete the {{count}} selected sources',
    apagarSelCampanhas_one: 'Delete the selected campaign',
    apagarSelCampanhas_other: 'Delete the {{count}} selected campaigns',
    apagarTodasFontes: 'Delete all {{count}} sources',
    apagarTodasCampanhas: 'Delete all {{count}} campaigns',
    confirmarFontes: 'Delete {{count}} sources?',
    confirmarCampanhas: 'Delete {{count}} campaigns?',
  },
  motivos: {
    titulo: 'Loss reason',
    intro1: "Register all the reasons your company's deals are lost.",
    intro2: 'Besides the reports, you get filters to follow companies and customers more closely.',
    adicionar: 'Add loss reason',
    campo: 'Loss reason',
    placeholder: "E.g.: Didn't like the product",
    coluna: 'Loss reason name',
    perdidas: 'Lost deals',
    apagarSel_one: 'Delete the selected reason',
    apagarSel_other: 'Delete the {{count}} selected reasons',
    apagarTodos: 'Delete all {{count}} loss reasons',
    confirmar: 'Delete {{count}} loss reasons?',
  },
  qualificacao: {
    sub: 'Set qualification criteria to organize and prioritize the deals in the pipeline.',
    autoTitulo: 'Automatic qualification via questionnaires',
    autoTexto_one: '{{count}} questionnaire qualifies the deals by the score of the answers.',
    autoTexto_other: '{{count}} questionnaires qualify the deals by the score of the answers.',
    autoNenhum: 'No questionnaire qualifies yet. Turn on automatic qualification in the questionnaire and set the score ranges.',
    autoLink: 'See the questionnaires',
    colQualificacao: 'Qualification',
    colNome: 'Name',
    editar: 'Edit {{nome}}',
    editarTitulo: 'Edit qualification',
    nome: 'Qualification name',
  },
  questionarios: {
    sub: 'Standardize the questions asked to customers and how their answers are recorded.',
    avisoTitulo: 'Automate your qualification',
    avisoTexto: 'Rank the deals by the questionnaire score. To start,',
    avisoLink: 'set up the qualification',
    colQuestionario: 'Questionnaire',
    colPerguntas: 'Questions',
    colRespostas: 'Answers',
    colEdicao: 'Last edited',
    colAtivo: 'In use',
    opcoes: 'Options for {{nome}}',
    verRespostas: 'See answers',
    excluir: 'Delete',
    vazioTitulo: "Take the first step to standardize how you collect your customers' information",
    vazioTexto: 'Create a questionnaire so the whole team asks the same questions and records the answers in an organized way.',
    novo: 'New questionnaire',
  },
  modelos: {
    sub: 'Create, edit and organize the proposal templates used in deals.',
    criar: 'Create template',
    filtro: 'Filter the templates',
    todos: 'All templates',
    publicados: 'Published',
    rascunhos: 'Drafts',
    colModelo: 'Proposal templates',
    colStatus: 'Status',
    colAcoes: 'Actions',
    publicado: 'Published',
    rascunho: 'Draft',
    opcoes: 'Options for {{nome}}',
    editar: 'Edit template',
    tornarPadrao: 'Make default',
    duplicar: 'Duplicate',
    copia: '{{nome}} (copy)',
    duplicado: 'Template duplicated',
    moverRascunho: 'Move to draft',
    publicar: 'Publish',
    excluir: 'Delete',
    vazio: 'No template in this filter.',
    salvarAlteracoes: 'Save changes',
    definicoes: 'Template settings',
    conteudo: 'Template content',
    novoTitulo: 'New template',
    salvo: 'Changes saved',
    naoEncontrado: 'Template not found.',
  },
  modelosEmail: {
    intro: 'Register e-mail templates to send to contacts from the deals.',
    adicionar: 'Add template',
    fechar: 'Close',
    apagarSel_one: 'Delete the selected template',
    apagarSel_other: 'Delete the {{count}} selected templates',
    confirmarApagar_one: 'Delete the selected template?',
    confirmarApagar_other: 'Delete the {{count}} selected templates?',
  },
  preferencias: {
    abaTroca: 'Deal transfer and creation',
    abaArquivos: 'File center',
    abaGatilhos: 'Triggers',
    abaNegociacao: 'Deal',
    abaTokens: 'API tokens',
    celebrar: 'Turn on the celebration when a sale is closed?',
    celebrarAjuda: "When a deal is marked as won, the CRM shows the seller a celebration message with the number and value of the month's sales.",
  },
  central: {
    intro1: 'Turn this page into the company file repository: images, presentations, portfolio and standard documents.',
    intro2: 'Files here can go as attachments in "Create email" and when sending a proposal, through the "Files from the File center" button.',
    intro3: 'Set each file as exclusive to who manages the File center or shared with the whole team. Up to {{limite}} per file (image, PDF, Office, OpenDocument, text or CSV) and {{max}} files.',
    upload: 'Upload files',
    enviando: 'Uploading {{nome}}...',
    enviados_one: 'File uploaded',
    enviados_other: '{{count}} files uploaded',
    data: 'Date',
    arquivo: 'File',
    tamanho: 'Size',
    adicionadoPor: 'Added by',
    abrir: 'Open',
    abrirNome: 'Open {{nome}}',
    link: 'Link',
    copiarLink: 'Copy the link of {{nome}}',
    linkCopiado: 'Link copied',
    compartilhado: 'Shared',
    compartilhadoNome: 'Share {{nome}} with the whole team',
    opcoes: 'Options',
    excluirNome: 'Delete {{nome}}',
    excluirTitulo: 'Delete file',
    excluirTexto: 'Delete "{{nome}}" from the File center? What was already sent in emails stays in the deals.',
    excluido: 'File deleted',
    salvo: 'Preference saved',
    vazio: 'No files uploaded.',
    semPermissao: 'You see the shared files. Uploading, sharing and deleting require the "Manage the File center" permission and seeing all companies in the workspace.',
    tipo: 'File type not allowed: {{nome}}',
    grande: '{{nome}} is over {{limite}}',
    escolher: 'Files from the File center',
    escolherTitulo: 'Files from the File center',
    escolherAjuda: 'Check the files to attach. They count with the other attachments toward the email limit.',
    escolherVazio: 'The File center has no shared files yet.',
    escolherConfirmar: 'Use the checked files',
    escolherNome: 'Choose {{nome}}',
    removerNome: 'Remove {{nome}} from the email',
    daCentral: 'From the File center',
    texto: 'Text about the files (optional)',
    textoAjuda: 'Goes into the email body before the signature (without a signature, at the end). It comes from the files\' template text; change or delete it. {{n}}/2000',
    textoModelo: 'Template text (optional)',
    textoModeloAjuda: 'Goes into the email body, before the signature, when the file is attached. {{n}}/2000',
    textoModeloPlaceholder: 'E.g.: Please find our service portfolio attached.',
    enviarTitulo: 'Upload to the File center',
    enviarConfirmar: 'Upload',
    editarTexto: 'Template text of {{nome}}',
    textoSalvo: 'Template text saved',
    comTexto: 'Template text: {{texto}}',
    textoPlaceholder: 'E.g.: Please find our service portfolio attached.',
    // 03/11 list: vertical and general portfolio, and the "Discover our other services" text.
    portfolioTitulo: 'Portfolios',
    portfolioIntro: 'Choose the file in the File center that is the portfolio of each business unit and the group one. When the Emails tab email or the proposal email opens, the group portfolio and those of the business units that are not in the deal come checked; the sender can change them before sending.',
    portfolioGeral: 'Malgo General',
    portfolioSem: 'No file',
    portfolioSelecionar: 'Portfolio file for {{nome}}',
    portfolioEmUso: '{{nome}} (portfolio of {{opcao}})',
    portfolioSalvarNome: 'Save the portfolio of {{nome}}',
    portfolioSalvo: 'Portfolio saved',
    portfolioSemArquivosNaCentral: 'Upload files to the File center to choose the portfolios.',
    outrosTitulo: 'Discover our other services',
    outrosAjuda: 'Goes into the body of the Emails tab email and of the proposal email, and the address becomes a link. Leave empty to leave it out. {{n}}/500',
    outrosCampo: 'Other services text',
    outrosPlaceholder: 'E.g.: Discover our other services: https://malgo.com.br',
    outrosSalvo: 'Text saved',
    outrosPadrao: 'Back to the default text',
    envioPortfolioTitulo: 'Portfolios',
    envioPortfolioAjuda: 'The group portfolio and those of the business units that are not in the deal come checked. Uncheck what you do not want: nothing is sent on its own.',
    envioVerticaisErro: 'Could not read the deal business units. Business unit portfolios did not come checked; check them here if you need them.',
    envioPortfolioCarregando: 'Loading the portfolios...',
    envioOutrosErro: 'Could not load the other services text. The email goes on without it; you can write it in the body.',
    envioPortfolioErro: 'Could not load the portfolios. Sending goes on without them; you can still attach from the File center.',
    envioPortfolioFalta: 'No file yet. Upload it in CRM settings > Preferences > File center.',
    envioPortfolioNaoCoube: '{{arquivo}} did not fit the email limits and was left unchecked. The File center link requires login, so it is not put in the body.',
    envioPortfolioMarcar: 'Attach the {{opcao}} portfolio: {{arquivo}}',
    envioPortfolioSemArquivoNome: '{{opcao}} portfolio: no file',
  },
};

export const cfgEs: typeof cfgPt = {
  migalha: 'Configuración',
  voltar: 'Volver a la configuración',
  novo: 'Nuevo',
  lista: {
    pesquisar: 'Buscar...',
    descricao: 'Descripción',
    descricaoPlaceholder: 'Ej.: Acción de fin de año',
    opcoes: 'Opciones',
    vazio: 'Ningún elemento registrado.',
    selecionarTodos: 'Seleccionar todos',
    selecionar: 'Seleccionar {{nome}}',
    editar: 'Editar {{nome}}',
    excluir: 'Eliminar {{nome}}',
    confirmarUm: '¿Eliminar "{{nome}}"?',
    confirmarTexto: 'El elemento sale de la lista de opciones. Lo que ya se registró con él queda como está.',
    repetido: 'Ya existe un elemento con ese nombre',
  },
  sugestoes: { usuarios: 'Invita a las personas de tu equipo a usar el CRM', usuariosBotao: 'Invitar usuarios' },
  funis: {
    titulo: 'Embudos de ventas',
    abaFunil: 'Embudo de ventas',
    abaCrm2crm: 'CRM2CRM',
    adicionarFunil: 'Agregar embudo de ventas',
    nomeFunil: 'Nombre del embudo',
    placeholderFunil: 'Ej.: Posventa',
    copiarDe: 'Copiar las etapas de',
    semCopia: 'Etapas predeterminadas',
    opcoesFunil: 'Opciones del embudo {{nome}}',
    renomear: 'Renombrar',
    renomearTitulo: 'Renombrar embudo',
    arquivar: 'Archivar embudo',
    confirmarArquivar: '¿Archivar el embudo {{nome}}?',
    confirmarArquivarTexto: 'El embudo sale de la elección de embudo y el historial queda. Solo se puede archivar un embudo sin negociaciones abiertas.',
    arquivados_one: '{{count}} embudo archivado',
    arquivados_other: '{{count}} embudos archivados',
    desarquivar: 'Desarchivar',
    etapaConfigurada: 'Etapa configurada',
    adicionarEtapa: 'Agregar etapa al embudo {{nome}}',
    excluirEtapa: 'Eliminar etapa',
    etapas: 'Etapas del embudo {{nome}}',
    etapasNovo: 'Etapas del embudo',
    etapasNovoAjuda: 'En el orden del tablero. Cambia el nombre, agrega y cambia el orden con las flechas o arrastrando.',
    nomeEtapaN: 'Nombre de la etapa {{n}}',
    etapaN: 'etapa {{n}}',
    novaEtapa: 'Agregar etapa',
    removerEtapa: 'Quitar la etapa {{nome}}',
    etapaRepetida: 'Ya existe una etapa con ese nombre',
    faltaTipo: 'El embudo necesita al menos una etapa del tipo {{tipo}}',
  },
  campos: {
    titulo: 'Configurar campos de registro',
    abaNegociacao: 'Negociación',
    abaEmpresa: 'Empresas',
    abaContato: 'Contactos',
    abaProduto: 'Productos y servicios',
    semPermissao: 'Los campos personalizados están en la configuración del sistema. Para verlos aquí, pide el permiso de ver la configuración.',
  },
  produtos: {
    titulo: 'Productos y servicios',
    intro: 'El catálogo de venta que usa la negociación. El formulario es el mismo del botón "Crear nuevo producto/servicio".',
    criar: 'Crear producto/servicio',
    criarTitulo: 'Nuevo producto/servicio',
    editarTitulo: 'Editar producto/servicio',
    editar: 'Editar {{nome}}',
    buscar: 'Busca por nombre o código',
    vazio: 'Ningún producto o servicio registrado.',
    semResultado: 'No se encontró nada para esta búsqueda.',
    salvo: 'Producto/servicio guardado',
    verticalVarias: 'Varias verticales (mantener como están)',
    verticalSempreAjuda: 'Puede ser una vertical fuera del filtro de la negociación: el registro se crea, pero no entra en la lista de ella.',
    foraDoFiltro: 'El registro "{{nome}}" se creó en {{vertical}}, que está fuera del filtro de vertical de esta negociación. No aparece en la lista ni fue elegido.',
    campos: 'Campos personalizados',
  },
  fontes: {
    abaFontes: 'Fuentes',
    abaCampanhas: 'Campañas',
    introFontes: 'Gestiona las fuentes de las negociaciones.',
    introCampanhas: 'Gestiona las campañas de las negociaciones.',
    livresFontes: 'Permitir que los usuarios creen nuevas fuentes',
    livresCampanhas: 'Permitir que los usuarios creen nuevas campañas',
    adicionarFontes: 'Agregar fuente',
    adicionarCampanhas: 'Agregar campaña',
    campoFontes: 'Nombre de la fuente',
    campoCampanhas: 'Nombre de la campaña',
    placeholderFontes: 'Ej.: Contacto por el sitio',
    placeholderCampanhas: 'Ej.: Google Ads',
    apagarSelFontes_one: 'Eliminar la fuente seleccionada',
    apagarSelFontes_other: 'Eliminar las {{count}} fuentes seleccionadas',
    apagarSelCampanhas_one: 'Eliminar la campaña seleccionada',
    apagarSelCampanhas_other: 'Eliminar las {{count}} campañas seleccionadas',
    apagarTodasFontes: 'Eliminar todas las {{count}} fuentes',
    apagarTodasCampanhas: 'Eliminar todas las {{count}} campañas',
    confirmarFontes: '¿Eliminar {{count}} fuentes?',
    confirmarCampanhas: '¿Eliminar {{count}} campañas?',
  },
  motivos: {
    titulo: 'Motivo de pérdida',
    intro1: 'Registra todos los motivos de pérdida de negociaciones de tu empresa.',
    intro2: 'Además de los informes, tendrás filtros para seguir mejor a las empresas y a los clientes.',
    adicionar: 'Agregar motivo de pérdida',
    campo: 'Motivo de pérdida',
    placeholder: 'Ej.: No le gustó el producto',
    coluna: 'Nombre del motivo de pérdida',
    perdidas: 'Negociaciones perdidas',
    apagarSel_one: 'Eliminar el motivo seleccionado',
    apagarSel_other: 'Eliminar los {{count}} motivos seleccionados',
    apagarTodos: 'Eliminar todos los {{count}} motivos de pérdida',
    confirmar: '¿Eliminar {{count}} motivos de pérdida?',
  },
  qualificacao: {
    sub: 'Define criterios de calificación para organizar y priorizar las negociaciones en el embudo.',
    autoTitulo: 'Calificación automática por cuestionarios',
    autoTexto_one: '{{count}} cuestionario califica las negociaciones por la puntuación de las respuestas.',
    autoTexto_other: '{{count}} cuestionarios califican las negociaciones por la puntuación de las respuestas.',
    autoNenhum: 'Ningún cuestionario califica todavía. Activa la calificación automática en el cuestionario y define los rangos de puntos.',
    autoLink: 'Ver los cuestionarios',
    colQualificacao: 'Calificación',
    colNome: 'Nombre',
    editar: 'Editar {{nome}}',
    editarTitulo: 'Editar calificación',
    nome: 'Nombre de la calificación',
  },
  questionarios: {
    sub: 'Estandariza las preguntas hechas a los clientes y el registro de las respuestas.',
    avisoTitulo: 'Automatiza tu calificación',
    avisoTexto: 'Clasifica las negociaciones por la puntuación de los cuestionarios. Para empezar,',
    avisoLink: 'configura la calificación',
    colQuestionario: 'Cuestionario',
    colPerguntas: 'Preguntas',
    colRespostas: 'Respuestas',
    colEdicao: 'Última edición',
    colAtivo: 'En uso',
    opcoes: 'Opciones de {{nome}}',
    verRespostas: 'Ver respuestas',
    excluir: 'Eliminar',
    vazioTitulo: 'Da el primer paso para estandarizar la recolección de información de tus clientes',
    vazioTexto: 'Crea un cuestionario para que todo el equipo haga las mismas preguntas, con las respuestas registradas de forma organizada.',
    novo: 'Nuevo cuestionario',
  },
  modelos: {
    sub: 'Crea, edita y organiza las plantillas de propuesta usadas en las negociaciones.',
    criar: 'Crear plantilla',
    filtro: 'Filtrar las plantillas',
    todos: 'Todas las plantillas',
    publicados: 'Publicadas',
    rascunhos: 'Borradores',
    colModelo: 'Plantillas de propuesta',
    colStatus: 'Estado',
    colAcoes: 'Acciones',
    publicado: 'Publicada',
    rascunho: 'Borrador',
    opcoes: 'Opciones de {{nome}}',
    editar: 'Editar plantilla',
    tornarPadrao: 'Hacer predeterminada',
    duplicar: 'Duplicar',
    copia: '{{nome}} (copia)',
    duplicado: 'Plantilla duplicada',
    moverRascunho: 'Mover a borrador',
    publicar: 'Publicar',
    excluir: 'Eliminar',
    vazio: 'Ninguna plantilla en este filtro.',
    salvarAlteracoes: 'Guardar cambios',
    definicoes: 'Definiciones de la plantilla',
    conteudo: 'Contenido de la plantilla',
    novoTitulo: 'Nueva plantilla',
    salvo: 'Cambios guardados',
    naoEncontrado: 'Plantilla no encontrada.',
  },
  modelosEmail: {
    intro: 'Registra plantillas de correo para enviar a los contactos desde las negociaciones.',
    adicionar: 'Agregar plantilla',
    fechar: 'Cerrar',
    apagarSel_one: 'Eliminar la plantilla seleccionada',
    apagarSel_other: 'Eliminar las {{count}} plantillas seleccionadas',
    confirmarApagar_one: '¿Eliminar la plantilla seleccionada?',
    confirmarApagar_other: '¿Eliminar las {{count}} plantillas seleccionadas?',
  },
  preferencias: {
    abaTroca: 'Cambio y creación de negociaciones',
    abaArquivos: 'Central de archivos',
    abaGatilhos: 'Disparadores',
    abaNegociacao: 'Negociación',
    abaTokens: 'Tokens de API',
    celebrar: '¿Activar la celebración al cerrar una venta?',
    celebrarAjuda: 'Al marcar una negociación como vendida, el CRM muestra a quien vendió un mensaje de celebración con la cantidad y el valor de las ventas del mes.',
  },
  central: {
    intro1: 'Convierte esta página en el repositorio de archivos de la empresa: imágenes, presentaciones, portafolio y documentos estándar.',
    intro2: 'Los archivos de aquí pueden ir como adjuntos en "Crear correo" y en el envío de la propuesta, con el botón "Archivos de la Central".',
    intro3: 'Define si cada archivo es exclusivo de quien gestiona la Central o compartido con todo el equipo. Hasta {{limite}} por archivo (imagen, PDF, Office, OpenDocument, texto o CSV) y {{max}} archivos.',
    upload: 'Subir archivos',
    enviando: 'Subiendo {{nome}}...',
    enviados_one: 'Archivo subido',
    enviados_other: '{{count}} archivos subidos',
    data: 'Fecha',
    arquivo: 'Archivo',
    tamanho: 'Tamaño',
    adicionadoPor: 'Agregado por',
    abrir: 'Abrir',
    abrirNome: 'Abrir {{nome}}',
    link: 'Enlace',
    copiarLink: 'Copiar el enlace de {{nome}}',
    linkCopiado: 'Enlace copiado',
    compartilhado: 'Compartido',
    compartilhadoNome: 'Compartir {{nome}} con todo el equipo',
    opcoes: 'Opciones',
    excluirNome: 'Eliminar {{nome}}',
    excluirTitulo: 'Eliminar archivo',
    excluirTexto: '¿Eliminar "{{nome}}" de la Central? Lo que ya se envió en los correos sigue en las negociaciones.',
    excluido: 'Archivo eliminado',
    salvo: 'Preferencia guardada',
    vazio: 'Ningún archivo subido.',
    semPermissao: 'Ves los archivos compartidos. Subir, compartir y eliminar requiere el permiso "Gestionar la Central de archivos" y ver todas las empresas del workspace.',
    tipo: 'Tipo de archivo no permitido: {{nome}}',
    grande: '{{nome}} supera {{limite}}',
    escolher: 'Archivos de la Central',
    escolherTitulo: 'Archivos de la Central',
    escolherAjuda: 'Marca los archivos que van como adjunto. Suman con los otros adjuntos en el límite del correo.',
    escolherVazio: 'La Central de archivos todavía no tiene archivos compartidos.',
    escolherConfirmar: 'Usar los archivos marcados',
    escolherNome: 'Elegir {{nome}}',
    removerNome: 'Quitar {{nome}} del correo',
    daCentral: 'De la Central',
    texto: 'Texto sobre los archivos (opcional)',
    textoAjuda: 'Entra en el cuerpo del correo antes de la firma (sin firma, al final). Viene del texto modelo de los archivos; puedes cambiarlo o borrarlo. {{n}}/2000',
    textoModelo: 'Texto modelo (opcional)',
    textoModeloAjuda: 'Entra en el cuerpo del correo, antes de la firma, cuando se adjunta el archivo. {{n}}/2000',
    textoModeloPlaceholder: 'Ej.: Te enviamos adjunto nuestro portafolio de servicios.',
    enviarTitulo: 'Enviar a la Central',
    enviarConfirmar: 'Enviar',
    editarTexto: 'Texto modelo de {{nome}}',
    textoSalvo: 'Texto modelo guardado',
    comTexto: 'Texto modelo: {{texto}}',
    textoPlaceholder: 'Ej.: Te enviamos adjunto nuestro portafolio de servicios.',
    // Lista del 03/11: portafolio de la vertical y general, y el texto "Conoce nuestros otros servicios".
    portfolioTitulo: 'Portafolios',
    portfolioIntro: 'Elige el archivo de la Central que es el portafolio de cada vertical y el del grupo. Al abrir el correo de la pestaña Correos o el de la propuesta, el general y el portafolio de las verticales que no están en la negociación ya vienen marcados; quien envía puede cambiarlos antes de enviar.',
    portfolioGeral: 'Malgo General',
    portfolioSem: 'Sin archivo',
    portfolioSelecionar: 'Archivo del portafolio de {{nome}}',
    portfolioEmUso: '{{nome}} (portafolio de {{opcao}})',
    portfolioSalvarNome: 'Guardar el portafolio de {{nome}}',
    portfolioSalvo: 'Portafolio guardado',
    portfolioSemArquivosNaCentral: 'Sube los archivos a la Central para elegir los portafolios.',
    outrosTitulo: 'Conoce nuestros otros servicios',
    outrosAjuda: 'Entra en el cuerpo del correo de la pestaña Correos y del correo de la propuesta, y la dirección se vuelve enlace. Déjalo vacío para no incluirlo. {{n}}/500',
    outrosCampo: 'Texto de los otros servicios',
    outrosPlaceholder: 'Ej.: Conoce nuestros otros servicios: https://malgo.com.br',
    outrosSalvo: 'Texto guardado',
    outrosPadrao: 'Volver al texto predeterminado',
    envioPortfolioTitulo: 'Portafolios',
    envioPortfolioAjuda: 'El general del grupo y el portafolio de las verticales que no están en la negociación vienen marcados. Desmarca lo que no quieras: nada sale solo.',
    envioVerticaisErro: 'No se pudieron leer las verticales de la negociación. Los portafolios de vertical no vinieron marcados; márcalos aquí si los necesitas.',
    envioPortfolioCarregando: 'Cargando los portafolios...',
    envioOutrosErro: 'No se pudo cargar el texto de otros servicios. El correo sigue sin él; puedes escribirlo en el cuerpo.',
    envioPortfolioErro: 'No se pudieron cargar los portafolios. El envío sigue sin ellos; aún puedes adjuntar desde la Central.',
    envioPortfolioFalta: 'Aún sin archivo. Súbelo en Configuraciones del CRM > Preferencias > Central de archivos.',
    envioPortfolioNaoCoube: '{{arquivo}} no cupo en los límites del correo y quedó desmarcado. El enlace de la Central pide inicio de sesión, por eso no va en el cuerpo.',
    envioPortfolioMarcar: 'Adjuntar el portafolio de {{opcao}}: {{arquivo}}',
    envioPortfolioSemArquivoNome: 'Portafolio de {{opcao}}: sin archivo',
  },
};
